import React from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';
import {
  SocialButtonIcon,
  SociaButtonTitle,
  SocialIcon,
} from '../styles';

import {
  LinkedinButtonContainer,
} from './styles';

const LINKED_IN_BUTTON = { bg: '#2a7bb6', icon: 'linkedin', name: 'LinkedIn' };

const LinkedInButton = ({ href }) => {
  const { bg, icon, name } = LINKED_IN_BUTTON;

  const { pathname } = useLocation();

  const signText = pathname.includes('sign-up') ? 'Sign Up' : 'Sign In';
  const buttonText = `${signText} with ${name}`;

  const handleClick = () => {
    window.location = href;
  };

  return (
    <LinkedinButtonContainer bg={bg} onClick={handleClick} href={href}>
      <SocialButtonIcon>
        <SocialIcon name={icon} />
      </SocialButtonIcon>
      <SociaButtonTitle>
        {buttonText}
      </SociaButtonTitle>
    </LinkedinButtonContainer>
  );
};

LinkedInButton.propTypes = {
  href: PropTypes.string,
};

LinkedInButton.defaultProps = {
  href: '',
};

export default LinkedInButton;
